import { connect } from 'react-redux'
import Footer from './Footer'

import selectTotals from './Selectors/selectTotals'

import onClickEdit from './Handlers/onClickEdit'
import onClickSave from './Handlers/onClickSave'
import onClickCancel from './Handlers/onClickCancel'

const mapStateToProps = (state) => ({
  editing: state.screens.SubValuation.editing,
  saving: state.screens.SubValuation.saving,
  totals: selectTotals(state),
})

const actionCreators = {
  onClickEdit,
  onClickSave,
  onClickCancel,
}

export default connect(mapStateToProps, actionCreators)(Footer)
